import { createRoot } from "react-dom/client"

import { useI18nStore } from "@/locales"
import textCommon from "@/locales/zh-CN.json"
import { sdkReady } from "@/utils/sdk"
import { Root } from "../../pre"
import { useTopicI18nStore } from ".."
import game from "./json/game.json"
import text from "./json/text.json"
import { TOPIC_STORE } from "./store"

useI18nStore.setState({
    text: {
        ...textCommon,
        ...text,
        ...game,
    },
    sdkReady,
    collect: (...params) => {
        sdkReady((sdk) => sdk.ETL.event(...params))
    },
})
useTopicI18nStore.setState(TOPIC_STORE)

const container = document.getElementById("root")
if (container) {
    const root = createRoot(container)
    root.render(<Root />)
}
